import { render, staticRenderFns } from "./TraceRecord.vue?vue&type=template&id=432deaca&"
import script from "./TraceRecord.vue?vue&type=script&lang=ts&"
export * from "./TraceRecord.vue?vue&type=script&lang=ts&"
import style0 from "./TraceRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports